import {
  LocalStorageController,
  LOCAL_STORAGE_DATA,
} from "./LocalStorageController";
import { authWithPiNetwork } from "./PiIntegration";
import weAreOnPiBrowser from "./weAreOnPiBrowser";

export default async function getUserSignInData() {
  // Check if we're on localhost
  const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname.includes("athtest");

  if (isLocalhost) {
    return {
      email: undefined,
      password: undefined,
      path: "pi" as const,
      piAccessToken: "xxx",
    };
  }

  const email = LocalStorageController.connect().getData(
    LOCAL_STORAGE_DATA.EMAIL,
    "string"
  ) as string;
  const password = LocalStorageController.connect().getData(
    LOCAL_STORAGE_DATA.PASSWORD,
    "string"
  ) as string;
  const path: "email" | "pi" = "pi";
  const piAccessToken = weAreOnPiBrowser()
    ? (await authWithPiNetwork())?.accessToken
    : undefined;
  return { email, password, path, piAccessToken };
}
